const nsp = 'cart/';

export const SET_ALL_CART_ITEMS = `${nsp}SET_ALL_CART_ITEMS`;
export const SET_NEW_CART_ITEM = `${nsp}SET_NEW_CART_ITEM`;
export const UPDATE_CART_ITEM = `${nsp}UPDATE_CART_ITEM`;
export const RESET_CART = `${nsp}RESET_CART`;
